// extracted by mini-css-extract-plugin
export default {"spinner":"_1rSmv-ju","spinAround":"_3mXWU7La","inverted":"C3lqU74P","small":"_2TkEElFy","large":"_3RYJxAfI"};